var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        role: "presentation",
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "363.6 113 93.6 93.5",
      },
    },
    [
      _c("path", {
        attrs: {
          fill: "#AAA",
          d: "M455 115c-6.5-6.5-60.6 3.9-76.1 19.4-12.6 12.6-13.5 33.7-2.4 49.3l-12.9 9.6 13.2 13.2 9.9-12.8c16.1 11.7 36.5 10.1 49-2.5 15.9-16.1 26.2-69.3 19.3-76.2z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }